export default "__VITE_ASSET__B87UJ1p5__"